import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { HeaderSearch } from '@/components/content/Header/parts/HeaderSearch';
import { HeaderMiniCart } from '@/components/content/Header/parts/MiniCart';
import { HeaderMobileDrawer } from '@/components/content/Header/parts/MobileDrawer';
import { SearchMobileDrawer } from '@/components/content/Header/parts/MobileDrawerSearch';
import { HeaderMobileToggleButton } from '@/components/content/Header/parts/MobileToggleButton';
import { useHeader } from '@/data/Content/Header';
import { useOnboardingTour } from '@/data/Content/OnboardingTour';
import { ID } from '@/data/types/Basic';
import { Stack } from '@mui/material';
import { useCallback, useState } from 'react';

export const HeaderNavBarMobile: React.FC<{
	id: ID;
	navBarRecommendation: JSX.Element;
}> = ({ id, navBarRecommendation }) => {
	const { contentItems } = useHeader(id);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [searchDrawerOpen, setSearchOpen] = useState(false);
	const { onClickSearchOnboardingTour } = useOnboardingTour();

	const toggleDrawerSearch = useCallback(
		(open?: boolean) => (event: React.MouseEvent<any>) => {
			setSearchOpen(open !== undefined ? open : (current) => !current);
			onClickSearchOnboardingTour(event);
		},
		[onClickSearchOnboardingTour]
	);

	const toggleDrawer = useCallback(
		(open?: boolean) => () => {
			setDrawerOpen(open !== undefined ? open : (current) => !current);
		},
		[]
	);

	const logoId = `${id}-MainHeader_SuperiorSection`;

	return (
		<Stack
			width="100%"
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			spacing={2}
			px={2}
			py={1}
		>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="flex-start"
				maxWidth="129px"
				width="100%"
				spacing={2}
				sx={{ maxWidth: '129px' }}
			>
				{contentItems.map((properties) => (
					<ContentRecommendation key={logoId} id={logoId} properties={properties} />
				))}
			</Stack>
			<Stack direction="row" spacing={1} display="flex" alignItems="center">
				<HeaderSearch onOpen={toggleDrawerSearch(true)} />
				<SearchMobileDrawer
					toggleSearch={toggleDrawerSearch}
					open={searchDrawerOpen}
					navBarRecommendation={navBarRecommendation}
				/>
				<HeaderMiniCart />
				<HeaderMobileToggleButton toggleDrawer={toggleDrawer} open={drawerOpen} />
				<HeaderMobileDrawer toggleDrawer={toggleDrawer} open={drawerOpen} />
			</Stack>
		</Stack>
	);
};
